import { Action } from '@ngrx/store';
import {SelectFloorPayload, UpdateSelectedFloorPayload} from '../models/floor-plan';
import {AirComponentType} from '../../afb-api/enums/air-component-type.enum';

export enum FloorPlanViewActionTypes {
  SelectFloor = '[FloorPlanView] Select Floor',
  UpdateSelectedFloor = '[FloorPlanView] Update Selected Floor',
  DeselectFloor = '[FloorPlanView] Deselect Floor',
  DeselectFloorSuccess = '[FloorPlanView] Deselect Floor Success',
  SelectAirComponent = '[FloorPlanView] Select Air Component',
  UpdateSelectedAirComponent = '[FloorPlanView] Update Selected Air Component'
}

export class SelectFloor implements Action {
  readonly type = FloorPlanViewActionTypes.SelectFloor;

  constructor(public payload: SelectFloorPayload) {
  }
}

export class UpdateSelectedFloor implements Action {
  readonly type = FloorPlanViewActionTypes.UpdateSelectedFloor;

  constructor(public payload: UpdateSelectedFloorPayload) {
  }
}

export class DeselectFloor implements Action {
  readonly type = FloorPlanViewActionTypes.DeselectFloor;
}

export class DeselectFloorSuccess implements Action {
  readonly type = FloorPlanViewActionTypes.DeselectFloorSuccess;
}

export class SelectAirComponent implements Action {
  readonly type = FloorPlanViewActionTypes.SelectAirComponent;

  constructor(public payload: AirComponentType) {
  }
}

export class UpdateSelectedAirComponent implements Action {
  readonly type = FloorPlanViewActionTypes.UpdateSelectedAirComponent;

  constructor(public payload: AirComponentType) {
  }
}

export type FloorPlanViewActions =
  | SelectFloor
  | UpdateSelectedFloor
  | DeselectFloor
  | DeselectFloorSuccess
  | SelectAirComponent
  | UpdateSelectedAirComponent;
